export default __webpack_public_path__ + "static/media/e7.4b207796.webp";